module.exports = __webpack_public_path__ + "img/order.31185e5a.jpg";